import { forwardRef } from 'react';
import Expert from '@/components/Expert/legacy';

const ExpertProfileForm = forwardRef(function ExpertProfileForm({ expertId, onSaveSuccess, onDirtyChange, onStatusChange, onViewExpertDetail }, ref) {
    if (expertId === null || expertId === undefined) {
        return null;
    }

    return <Expert key={expertId === 0 ? 'new' : expertId} ref={ref} embedded expertId={expertId} onSaveSuccess={onSaveSuccess} onDirtyChange={onDirtyChange} onStatusChange={onStatusChange} onViewExpertDetail={onViewExpertDetail} />;
});

export default ExpertProfileForm;
